/**
 * src/lib/breadcrumbs.js
 *
 * Single source of truth for breadcrumb labels and crumb-building.
 *
 * Both the visible <Breadcrumb /> nav (components/layout/Breadcrumb.js)
 * and the SEO <BreadcrumbLD /> JSON-LD (components/shared/BreadcrumbLD.js)
 * derive from buildCrumbs(pathname) so they can never drift apart.
 */

export const LABELS = {
  'launch-an-mvno': 'Launch an MVNO',
  'aspiring-mvno': 'Aspiring MVNO',
  'existing-licensee': 'Existing Licensee',
  'mobile-brand': 'Mobile Brand',
  solutions: 'Solutions',
  'banks-and-fintechs': 'Banks & Fintechs',
  'consumer-brands': 'Consumer Brands',
  'enterprise-and-corporate-affinity': 'Enterprise & Corporate',
  'diaspora-and-affinity': 'Diaspora & Affinity',
  'iot-and-m2m': 'IoT & M2M',
  'foreign-mvno-landing': 'Foreign MVNO Landing',
  platform: 'Platform',
  'mcx-core': 'MCX Core',
  'mcx-bss': 'MCX BSS',
  'mcx-activate': 'MCX Activate',
  'mcx-marketplace': 'MCX Marketplace',
  regulatory: 'Regulatory',
  'ncc-mvno-framework': 'NCC MVNO Framework',
  'ndpa-and-data-protection': 'NDPA & Data Protection',
  'sim-registration-and-kyc': 'SIM Registration & KYC',
  'lawful-intercept': 'Lawful Intercept',
  partners: 'Partners',
  trust: 'Trust',
  about: 'About',
  'who-we-are': 'Who we are',
  'what-we-do': 'What we do',
  'how-we-do-it': 'How we do it',
  'company-facts': 'Company facts',
  leadership: 'Leadership',
  'board-of-directors': 'Board of Directors',
  'executive-officers': 'Executive Officers',
  'habib-ahmed': 'Habib Ahmed',
  'suleiman-umar': 'Suleiman Saidu Umar',
  contact: 'Contact',
  'book-a-call': 'Book a Call',
  insights: 'Insights',
  'news-and-insights': 'News and insights',
  legal: 'Legal',
  'privacy-policy': 'Privacy Policy',
  'terms-of-service': 'Terms of Service',
  'cookie-policy': 'Cookie Policy',
  accessibility: 'Accessibility',
};

const humaniseSlug = (seg) =>
  seg.replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

/**
 * Build the breadcrumb chain for a pathname.
 *
 * Always starts with Home; one item per non-empty path segment.
 * Returns: [{ label, href }]
 */
export function buildCrumbs(pathname) {
  const segments = pathname.split('/').filter(Boolean);
  return [
    { label: 'Home', href: '/' },
    ...segments.map((seg, i) => ({
      label: LABELS[seg] || humaniseSlug(seg),
      href: '/' + segments.slice(0, i + 1).join('/'),
    })),
  ];
}
